import * as utils from 'Utils';


// Single campaign by id — for explicit APP_BLOCK / CUSTOM mounts that carry
// data-prompt-id. CDN-cacheable per prompt id.
export function getPromptPayload(successCallback, errorCallback, promptId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`prompt-payloads/${promptId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// The account's active INLINE campaigns (with settings.placement) — the
// discovery source for SELECTOR placements the renderer must create mounts for.
export function getAccountInlinePromptPayloads(successCallback, errorCallback, accountId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`account-inline-prompt-payloads/${accountId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
